import React, { Suspense } from 'react';
import { lazyWithReload } from './lazyWithReload';

/**
 * usage example:
 * * export default loadable(() => import(\/\* webpackChunkName: "LoginPage" \*\/ './LoginPage'));
 */
export default (importCallback, loader = null) => {
  const TargetComponent = lazyWithReload(importCallback);
  return props => (
    <Suspense fallback={loader}>
      <TargetComponent {...props} />
    </Suspense>
  );
};
